var React = require('react');

function FilmIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.0418 0H0.958237C0.42895 0 0 0.44768 0 1V15.0003C0 15.5523 0.42895 16 0.958237 16H22.0418C22.571 16 23 15.5523 23 15V1C23 0.44768 22.571 0 22.0418 0ZM8.05 12.2666V3.73344L14.95 8L8.05 12.2666Z","fill":"white"}));
}

FilmIcon.defaultProps = {"width":"23","height":"16","viewBox":"0 0 23 16","fill":"none"};

module.exports = FilmIcon;

FilmIcon.default = FilmIcon;
